<template>
    <div ref="menuContainer" class="relative" @click="toggleMenu">
        <!-- Ícone de três pontinhos -->
        <svg class="w-6 h-6 cursor-pointer" fill="none" stroke="#ffffff" viewBox="0 0 24 24"
            @click.stop="toggleMenu">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v.01M12 12v.01M12 18v.01">
            </path>
        </svg>
        <!-- Menu de opções -->
        <div v-if="showMenu" :class="menuClasses" :style="{ width: menuWidth }"
            class="absolute glass_black_fixed shadow-lg shadow-slate-900 rounded-lg p-2 z-10 text-sm text-slate-100 border border-slate-800">
            <ul>
                <li v-for="option in options" :key="option.id" @click="option.action">
                    <img :src="option.icon || '/img/option.svg'" :style="{ width: iconWidth, height: iconHeight }"
                        class="icon mr-2" v-if="anyIconPresent">
                    {{ option.label }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopMenu',
    props: {
        options: Array,
        menuWidth: {
            type: String,
            default: '200px'  // Valor padrão
        },
        iconWidth: {
            type: String,
            default: '20px'  // Valor padrão
        },
        iconHeight: {
            type: String,
            default: '20px'  // Valor padrão
        },
        forceDirection: {
            type: String,
            default: ''  // Sem forçar direção por padrão
        }
    },
    data() {
        return {
            showMenu: false,
        };
    },
    computed: {
        menuClasses() {
            if (this.forceDirection) {
                switch (this.forceDirection) {
                    case 'left':
                        return 'left-0 right-auto';
                    case 'right':
                        return 'right-0 left-auto';
                    case 'top':
                        return 'top-0 bottom-auto';
                    case 'bottom':
                        return 'bottom-0 top-auto';
                    default:
                        return '';
                }
            } else {
                const { bottom, right, width, height } = this.$refs.menuContainer.getBoundingClientRect();
                const screenW = window.innerWidth;
                const screenH = window.innerHeight;
                const styles = [];

                if (bottom + height > screenH) {
                    styles.push('top-auto', 'bottom-full');
                } else {
                    styles.push('top-full', 'bottom-auto');
                }

                if (right + width > screenW) {
                    styles.push('right-0', 'left-auto');
                } else {
                    styles.push('left-0', 'right-auto');
                }

                return styles.join(' ');
            }
        },
        anyIconPresent() {
            return this.options.some(opt => opt.icon);
        }
    },
    methods: {
        toggleMenu(event) {
            this.showMenu = !this.showMenu;
            if (this.showMenu) {
                // Adiciona ouvintes quando o menu é mostrado
                document.addEventListener('keydown', this.handleEsc);
                document.addEventListener('click', this.handleClickOutside, true);
            } else {
                // Remove ouvintes quando o menu é escondido
                this.closeMenu();
            }
        },
        handleEsc(event) {
            if (event.key === "Escape") {
                this.closeMenu();
            }
        },
        handleClickOutside(event) {
            // Verifica se o clique foi fora do menuContainer
            if (!this.$refs.menuContainer.contains(event.target)) {
                this.closeMenu();
            }
        },

        closeMenu() {
            this.showMenu = false;
            document.removeEventListener('keydown', this.handleEsc);
            document.removeEventListener('click', this.handleClickOutside, true);
        }
    }
}
</script>

<style scoped>
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

li {
    padding: 0.5em 1em;
    cursor: pointer;
    display: flex;
    align-items: center;
}

li:hover {
    @apply bg-slate-950 rounded-lg;
}
</style>
